import { NgModule } from '@angular/core';
import { Routes, RouterModule} from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { VaccinationComponent } from './vaccination.component';
import { PendingChangesGuard } from '../../pending-changes.guard';

const VaccinationRoutes: Routes = [
    { path: '', component: VaccinationComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(VaccinationRoutes)
    ],
    exports: [
        RouterModule
    ],
    providers: []
})
export class VaccinationRoutingModule {}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-schedule/vaccination.routing.ts